/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, March 28th 2022, 8:53:55 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { USER_TASK_TYPES } from "lib/schemas";
import Grid from "@mui/material/Grid";
import { TaskTemplate } from "lib/schemas";
import { useWorkflowStore, getUserTaskTypesData } from "service-builder/stores";
import { getUserTaskTypeWidgets } from "./TaskTypeWidgets";
import { TaskTypeSelectorButton } from "./TaskTypeSelectorButton";

interface UserTaskTypeSelectorProps {
  saveNewTaskInfo: (optionalProperties: Partial<TaskTemplate>) => void;
}

export const UserTaskTypeSelector = (props: UserTaskTypeSelectorProps) => {
  const onChooseUserTaskType = (userTaskType: keyof typeof USER_TASK_TYPES, event) => {
    let userTaskDefaultOptions: Partial<TaskTemplate> = {};

    switch (userTaskType) {
      case "payment":
      case "resubmission":
        userTaskDefaultOptions = { client_task: true };
        break;
    }

    props.saveNewTaskInfo({ user_action_type: userTaskType, ...userTaskDefaultOptions });
  };

  const userTaskTypeWidgets = getUserTaskTypeWidgets(useWorkflowStore(getUserTaskTypesData));

  return (
    <>
      {Object.keys(userTaskTypeWidgets).map((userTaskTypeKey) => {
        const { userTaskTypeIcon, userTaskTypeTitle, userTaskTypeDescription } = userTaskTypeWidgets[userTaskTypeKey];
        return (
          <Grid item md={4} key={userTaskTypeKey}>
            <TaskTypeSelectorButton
              onClick={(event: React.MouseEvent<HTMLDivElement>) =>
                onChooseUserTaskType(userTaskTypeKey as keyof typeof USER_TASK_TYPES, event)
              }
              tooltipText={userTaskTypeDescription}
              customIcon={userTaskTypeIcon}
              customTitle={userTaskTypeTitle}
              bpmnNodeType="View"
            />
          </Grid>
        );
      })}
    </>
  );
};
